import { DeleteCommentOutDto } from '../../../types/comment.dto';

export const DELETE_COMMENT = 'DELETE_COMMENT';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_ERROR = 'DELETE_COMMENT_ERROR';
export const RESET_DELETE_COMMENT = 'RESET_DELETE_COMMENT';

export interface DeleteComment {
  type: typeof DELETE_COMMENT;
  payload: DeleteCommentOutDto;
}

export interface DeleteCommentSuccess {
  type: typeof DELETE_COMMENT_SUCCESS;
  payload: null;
}

export interface DeleteCommentError {
  type: typeof DELETE_COMMENT_ERROR;
  payload: string | boolean;
}

export interface ResetDeleteComment {
  type: typeof RESET_DELETE_COMMENT;
  payload: null;
}

export interface State {
  data: null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = DeleteComment | DeleteCommentSuccess | DeleteCommentError | ResetDeleteComment;
